module.exports = __webpack_public_path__ + "static/aboutus-222fe620d016505dd87638897a5b5649.png";